var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component-wrapper d-flex align-center justify-center"},[_c('v-card',{staticClass:"pa-4 d-flex flex-column justify-center align-center",attrs:{"max-width":"1400px","width":"100%","height":"100%"}},[_c('img',{attrs:{"src":require("../../assets/underConstrunction.png")}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }